module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "mon"
  }, [_c('span', {
    staticClass: "mo"
  }, [_vm._v("JANUARY")])]), _vm._v(" "), _c('p', {
    staticClass: "ChapTitle",
    attrs: {
      "id": "toc1"
    }
  }, [_c('span', {
    staticClass: "un"
  }, [_c('a', {
    attrs: {
      "id": "link2"
    }
  }), _vm._v("SWEETLY GATHERED ROUND HANDBAG")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-aut"
  }, [_vm._v("by Delia Randall")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/flow.jpg"
    }
  }), _vm._v(" This chic, lightweight handbag features handmade faux leather handles and lots of pocket options. The advantage of making your own handles is that they are more flexible to sew and more comfortable to wear. You may also use 8˝ premade hoop handles.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "80%",
      "src": "images/pg6_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "aut-head"
  }, [_vm._v("MEET THE DESIGNER")]), _vm._v(" "), _c('p', {
    staticClass: "aut-txt"
  }, [_vm._v("Delia Randall is a 30-year-old mother to three beautiful children, a wife to a very patient husband, and an avid sewist who mostly enjoys sewing clothing for her children. She also likes to craft, crochet, and capture it all through her love of photography. She has a weakness for milkshakes, gardening, stripes, pretty fabric (especially striped pretty fabric), and kids who ask to be read to. You can read more about what Delia is currently sewing on her blog, "), _c('i', [_vm._v("Delia Creates")]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "http://deliacreates.com",
      "target": "_blank"
    }
  }, [_vm._v("deliacreates.com")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "fis"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("Finished size:")]), _vm._v(" 16½˝ wide × 13¼˝ tall (without handles) × 6½˝ deep")]), _vm._v(" "), _c('p', {
    staticClass: "fis"
  }, [_c('span', {
    staticClass: "col"
  }, [_vm._v("Fabrics:")]), _vm._v(" Yarn-Dyed Essex from Robert Kaufman and Waterfront Park by Violet Craft from Michael Miller Fabrics")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("FABRIC REQUIREMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("For the outer bag:")]), _vm._v(" ¾ yard of light- to midweight apparel fabric (at least 40˝ wide)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("For the lining:")]), _vm._v(" 1⅛ yards of quilter’s cotton or silky polyester (at least 40˝ wide)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("For the handles:")]), _vm._v(" ¼ yard of faux leather or vinyl (55˝–60˝ wide) "), _c('i', [_vm._v("Omit if using store-bought hoop handles.")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("Additional supplies")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("½˝-wide upholstery cording:")]), _vm._v(" 50˝ (usually sold by the yard)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("Leather and universal sewing machine needles")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("Nylon zipper:")]), _vm._v(" 7˝ or longer")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "ocol"
  }, [_vm._v("•")]), _vm._v(" "), _c('b', [_vm._v("Hot-glue gun or masking tape")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "tip-head"
  }, [_c('b', [_vm._v("Delia’s Tip")])]), _vm._v(" "), _c('p', {
    staticClass: "tip-txt"
  }, [_vm._v("If you are using store-bought hoop handles, you can omit the faux leather or vinyl. I found my vinyl in the home decor fabric clearance section of my fabric store. Many fabric stores also sell vinyl and faux leather on very tall rolls found near the clear vinyl or tablecloth vinyl section.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("CUTTING")])]), _vm._v(" "), _c('p', {
    staticClass: "scut"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg15_1.jpg"
    }
  }), _vm._v(" "), _c('i', [_vm._v("Pattern is on "), _c('span', {
    attrs: {
      "href": "#/37_chapter31#pg156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pullout")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ch2"
  }, [_c('i', [_vm._v("From the vinyl, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 strips 2½˝ × 26½˝")]), _vm._v(" "), _c('p', {
    staticClass: "ch2"
  }, [_c('i', [_vm._v("Fold the outer fabric crosswise to a 13½˝ × 40˝ rectangle and cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 pieces using the Sweetly Gathered Handbag pattern, with the pattern placed on the fold")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ch2"
  }, [_c('i', [_vm._v("Fold the lining fabric lengthwise 12˝ from a selvage and cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 pieces using the Sweetly Gathered Handbag pattern, with the pattern placed on the fold")]), _vm._v(" "), _c('p', {
    staticClass: "ch2"
  }, [_c('i', [_vm._v("From the single layer above the fold, cut:")])]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("2 squares 10˝ × 10˝ for the welt zipper pocket")]), _vm._v(" "), _c('p', {
    staticClass: "ctxt"
  }, [_vm._v("1 rectangle 11˝ × 8˝ for the divided pocket")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sew"
  }, [_vm._v("Sewing")]), _vm._v(" "), _c('p', {
    staticClass: "s-txt"
  }, [_c('i', [_vm._v("Seam allowances are ½˝ unless otherwise noted.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh2"
  }, [_vm._v("Sew the Zipper Welt Pocket")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" Center 1 of the welt zipper pocket pieces in the middle of 1 of the lining pieces, right sides facing. Position it 4˝ below the top of the notched side. Pin it at each corner. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" Measure down 2˝ from the top of the welt pocket piece. Using a ruler and a fabric-marking pen, draw a rectangle that is ½˝ tall and 6˝ wide. Draw a line down the middle vertically and horizontally. Draw two 45º lines from each corner. There will be 2 triangles at each end. Slide a pin through the vertical midline. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" Sew around the entire rectangle and cut along the middle line and triangles. Be sure not to clip any stitches. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("C")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("4")]), _vm._v(" Remove the pins and push the pocket piece through the cut hole to the wrong side. Press. If the corners are puckering, turn the pocket inside out again and clip closer to the corner without clipping a stitch. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("D")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("5")]), _vm._v(" Pin the zipper in place beneath the rectangle, with the zipper pull all the way to 1 side. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("E")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("6")]), _vm._v(" Topstitch around the rectangle, securing the zipper in place, sewing as close as possible to the zipper teeth on the ends (see "), _c('span', {
    attrs: {
      "href": "#/34_chapter28#link36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Topstitching")]), _vm._v("). Use a zipper foot or move the needle position if necessary. Trim the excess zipper. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("F")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("7")]), _vm._v(" Place the second welt pocket piece on top of the first pocket piece, right sides together, and pin it in place. Sew just the 2 pocket pieces together around all 4 edges. The raw edges will be encased between the bag lining and outer pieces and do not need to be finished. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("G")])]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "tip-head"
  }, [_c('b', [_vm._v("Delia’s Tip")])]), _vm._v(" "), _c('p', {
    staticClass: "tip-txt"
  }, [_vm._v("I like to push the pins in with the heads away from the direction I will sew. That way I can remove the pins easily.")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sh2"
  }, [_vm._v("Sew the Divided Pocket")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" Fold the divided pocket piece in half, matching the short ends. Sew all the way around, leaving a 2˝ opening on 1 of the sides. Trim the corners.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" Turn the pocket right side out. Use a dull pencil or a chopstick to push out the corners; then press.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" Place the pocket piece in the center of the other lining piece about 6˝ down from the top, with the folded side at the top. Sew around the pocket close to the edges. Stitch a divider line down the middle, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "sh2"
  }, [_vm._v("Make the Handles")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" Cut the cording into 2 equal 25˝ lengths. Tape the ends with masking tape before cutting to prevent fraying.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" Set the machine’s stitch length to 3mm. Fold the vinyl over the cording. Fold each long end of the vinyl to the inside about ¼˝. Pinch the seam with your fingers to get it in place under the presser foot, put the foot down, and then put the needle down to hold it. Adjust your needle position, if necessary, so that you are stitching about ⅛˝ from the edge. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" Fold each edge of the vinyl inward for a few inches as you sew. Continue to fold and sew until you get about 4˝ from the end and then "), _c('i', [_vm._v("stop")]), _vm._v(". Connect the ends of the cording together with masking tape or hot glue and then resume sewing, overlapping the vinyl at the end. Repeat for the other handle. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("B")]), _vm._v(" & "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("C")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10_3.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "tip-head"
  }, [_c('b', [_vm._v("Delia’s Tip")])]), _vm._v(" "), _c('p', {
    staticClass: "tip-txt"
  }, [_vm._v("This takes patience, and possibly some practice. You may want to get extra cording and vinyl just in case. You might have a few wavy stitches, but overall it gives a really awesome finishing touch and a nice and comfortable strap.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh2"
  }, [_vm._v("Assemble the Bag")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("1")]), _vm._v(" Fold the darts at each lower corner of the lining and the outer bag pieces, right sides facing, and stitch with a ¼˝ seam allowance. Press each seam open. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("A")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("2")]), _vm._v(" Pin together the lining pieces with right sides facing, making sure the corner seams match up. Stitch all around the curved edge, leaving a 4˝ opening in the bottom for turning. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("B")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg11_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("3")]), _vm._v(" Repeat for the outer bag pieces and press the seams open for a nice clean look. You should now have an outer bag and a lining.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("4")]), _vm._v(" With the outer bag "), _c('i', [_vm._v("wrong side out")]), _vm._v(" and the lining "), _c('i', [_vm._v("right side out")]), _vm._v(", insert the lining into the outer bag with right sides facing. Pin the top edges, matching the notches and corners. Sew around all of the edges. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("C")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("5")]), _vm._v(" Clip into each inside corner at a 45º angle and trim each outside corner without cutting through the stitches. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("D")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("6")]), _vm._v(" Turn the bag right side out through the lining opening and press. Topstitch around just the side notches. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("E")])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("7")]), _vm._v(" Fold 1 top seam over the non-overlapped part of a prepared handle and pin evenly. This can take some wiggling and shifting. Just be sure the ends match up at the notches. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("F")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("8")]), _vm._v(" Check your sewing machine needle position and adjust as needed so that you are sewing about ⅛˝ away from the edge; then sew along the pinned edge. Shift the fabric as you go to keep it flat where you are stitching. Repeat for the second handle. "), _c('span', {
    staticClass: "ncol1"
  }, [_vm._v("G")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg12_5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ncol"
  }, [_vm._v("9")]), _vm._v(" Adjust the handle in each casing so that the overlap is not seen. Stitch the lining opening closed, and you’re done! Good job!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0b82aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_chapter01.vue
// module id = 72
// module chunks = 0